import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ expeditedUserphone: string }>;

export const DispatchExpeditedUserphone: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/ExpeditedUserPhone",
        expeditedUserphone: props.parameter.expeditedUserphone,
    });
};

export const chain = [DispatchExpeditedUserphone];

const setExpeditedUserphone = createHandlerChainRunner(chain, "setExpeditedUserphone");
export default setExpeditedUserphone;
